export { default as FloatingLabel, FloatingLabelWrapper } from './floating-label';
